import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
    providedIn: 'root',
})
export class EventsService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    getEvents(filters: any): Observable<any> {
        const body = this.setBody();

        if (filters !== null) {
            Object.keys(filters).forEach((filter) => {
                if (filters[filter] !== null && filters[filter] !== '') {
                    if (filters[filter] instanceof Array) {
                        body.set(filter, `[${filters[filter].join(',')}]`);
                    } else {
                        body.set(filter, filters[filter]);
                    }
                }
            });
        }

        return this.http.post(this.urlService + this.routeAdress.route_events_filter, body.toString());
    }

    getEventDetails(event): Observable<any> {
        const body = this.setBody();
        body.set('event', event);
        return this.http.post(this.urlService + this.routeAdress.route_events_details, body.toString());
    }

    confirmEventSub(event, grid): Observable<any> {
        const body = this.setBody();
        body.set('event', event);
        body.set('grid', grid);

        return this.http.post(this.urlService + this.routeAdress.route_events_confirm, body.toString());
    }

    addEventSub(event, grid) {
        const body = this.setBody();
        body.set('event', event);
        body.set('grid', grid);

        return this.http.post(this.urlService + this.routeAdress.route_events_add, body.toString());
    }

    cancelEventSub(event, grid, subscription) {
        const body = this.setBody();
        body.set('event', event);
        body.set('grid', grid);
        body.set('subscription', subscription);

        return this.http.post(this.urlService + this.routeAdress.route_events_cancel, body.toString());
    }
}
